// extracted by mini-css-extract-plugin
export default {"page":"Opportunity_page__tAMiZ"};